import { Logo, useNavigate } from "@/components/lib";
import americanFootball from "@/images/american-football.svg";
import Styles from "@/css/mainStyles";

export function ReviewApplication() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4 lg:gap-8 justify-center h-screen p-8 2xl:px-48 lg:w-1/2 text-center">
      <Logo className="w-80 lg:w-96 mx-auto my-5 lg:mb-12" />
      <img
        src={americanFootball}
        alt="Football"
        className="w-20 mx-auto"
      />
      <h1 className="font-bold text-2xl lg:text-4xl">
        Your application is being reviewed
      </h1>
      <h2 className="mt-3 text-xl">
        Your application is currently under review by our admin team. We
        carefully evaluate each submission to ensure everything meets our
        requirements.
      </h2>
      <h3 className="lg:text-lg">
        You can expect a response within 48 business hours. Thank you for your
        patience!
      </h3>
      <button type="button" className={Styles.submitButton + "  mb-auto"} onClick={() => navigate("/signin")}>
        Go to Login
      </button>
    </div>
  );
}
